module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/company/company.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/company/company.component.scss
// module chunks = main